import { DeviceService } from '@/services/device.service'
export default {
  data() {
    return {
      dataUser: JSON.parse(localStorage.getItem('userData')),
    }
  },
  methods: {
    canApprove(status, perrmission, user) {
      return status === 'NEW' && this.dataPermission.includes(perrmission)
    },
    canUpdate(status, perrmission) {
      return status === 'NEW' && this.dataPermission.includes(perrmission)
    },
    canReject(status, perrmission) {
      return status === 'NEW' && this.dataPermission.includes(perrmission)
    },
    canCancel(status, perrmission) {
      return status === 'NEW' && this.dataPermission.includes(perrmission)
    },
    detail(id) {
      const routeData = this.$router.resolve({
        path: `/quantity-material/${id}`,
      })
      window.open(routeData.href, '_blank')
    },
    edit(id) {
      this.$router.push({
        path: `/quantity-material/edit/${id}`,
      })
    },
    sendApproveItem(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn gửi duyệt phiếu điều chỉnh số lượng ${item.code} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Gửi duyệt phiếu điều chỉnh số lượng',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.showLoading = true
            const res = await DeviceService.sendApproveWarranty({
              id: item.id,
            })
            this.showLoading = false
            if (res.code === 1000) {
              this.showSuccessMx(`Gửi duyệt phiếu điều chỉnh số lượng thành công`)
              this.fetchData()
            } else this.showFailMx(res.message)
          }
        })
        .catch(() => {
          this.showLoading = false
        })
    },
    sendReceiveItem(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn tiếp nhận phiếu điều chỉnh số lượng ${item.code} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Tiếp nhận điều chỉnh số lượng',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.showLoading = true
            const res = await DeviceService.receiveWarranty({
              id: item.id,
            })
            this.showLoading = false
            if (res.code === 1000) {
              this.showSuccessMx(`Tiếp nhận điều chỉnh số lượng thành công`)
              this.fetchData()
            } else this.showFailMx(`${res.message}`)
          }
        })
        .catch(() => {
          this.showLoading = false
        })
    },
    approveItem(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn duyệt phiếu điều chỉnh số lượng vật tư không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Duyệt phiếu điều chỉnh số lượng vật tư',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            try {
              this.showLoading = true
              const res = await DeviceService.approveQuantityMaterial({
                id: item.id,
              })
              if (res.code === 1000) {
                this.showSuccessMx(`Duyệt phiếu điều chính số lượng vật tư thành công`)
                this.fetchData()
              } else this.showFailMx(`${res.message}`)
            } catch (error) {
              this.showFailMx(`${error.message}`)
            } finally {
              this.showLoading = false
            }
          }
        })
        .catch(() => {
          this.showLoading = false
        })
    },
    rejectItem(item) {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('textarea', { ref: 'rejectValue', class: 'form-control f12' }),
      ])
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lý do từ chối',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
          okDisabled: false,
        })
        .then(async value => {
          if (value) {
            this.showLoading = true
            const res = await DeviceService.rejectQuantityMaterial({
              id: item.id,
              reasonReject: this.$refs.rejectValue.value,
            })
            this.showLoading = false
            if (res.code === 1000) {
              this.showSuccessMx(`Từ chối phiếu điều chỉnh số lượng thành công`)
              this.fetchData()
            } else {
              this.showFailMx(res.message)
            }
          }
        })
        .catch(error => {
          this.showLoading = false
          this.showFailMx(error.message)
        })
    },
    cancelItem(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn huỷ phiếu điều chỉnh số lượng không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Hủy phiếu điều chỉnh số lượng',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.showLoading = true
            const res = await DeviceService.cancelQuantityMaterial({
              id: item.id,
            })
            this.showLoading = false
            if (res.code === 1000) {
              this.showSuccessMx(`Huỷ phiếu điều chỉnh số lượng thành công`)
              this.fetchData()
            } else this.showFailMx(res.message)
          }
        })
        .catch(() => {
          this.showLoading = false
        })
    },
  },
}
